import React from 'react';
import { LoyaltyIndicationBanner, LoyaltyIndicationBannerPointsMode } from '@fiverr-private/loyalty_indication';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { Gql } from '@fiverr-private/loyalty_utils';

export interface LoyaltyBannerProps {
  currency: { rate: number; name: string };
  seller: {
    isPro: boolean;
    displayName?: string;
    user?: {
      profile: {
        displayName: string;
      };
    };
  };
  currentPrice: number;
  isCollapsible?: boolean;
  containerStyles?: React.ComponentProps<typeof LoyaltyIndicationBanner>['containerStyles'];
}

export const LoyaltyBanner = ({
  currency,
  seller,
  currentPrice,
  isCollapsible,
  containerStyles,
}: LoyaltyBannerProps) => {
  const { loyaltyIndication = {} } = useGigPageContext();
  const sellerName = seller?.displayName || seller?.user?.profile?.displayName || '';
  return (
    <LoyaltyIndicationBannerPointsMode
      type="gig_page"
      data-testid="loyalty_indication_banner_points_mode"
      loyaltyIndicationData={loyaltyIndication as Gql.EngagementBadgeInfo}
      currency={currency}
      isCollapsible={isCollapsible}
      useTierIcon
      pointsAmount={(loyaltyIndication as Gql.EngagementBadgeInfo & { points: number })?.points || 0}
      containerStyles={containerStyles}
      gigInfo={{
        gigPriceInUSDCents: currentPrice || 0,
        isProSeller: seller?.isPro,
        sellerName,
      }}
    />
  );
};
